export const status = {
    DONE: 'done',
    UPLOADING: 'uploading',
    ERROR: 'error',
};
